var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{style:(_vm.cssVars),attrs:{"id":"CalendarPage"}}),_c('div',{staticClass:"absolute bottom-0 right-0 z-100",attrs:{"id":"FeatureDiscovery"}})])}
var staticRenderFns = []

export { render, staticRenderFns }